import { createContext, useState } from "react";

export const ShowProfileContext = createContext();

const ShowProfileContextProvider = ({ children }) => {
  const [showProfilePopUp, setShowProfilePopUp] = useState(false);
  const [profileApplyFlow, setProfileApplyFlow] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [onProfileCompleted, setOnProfileCompleted] = useState(null);

  const showProfile = ({
    isApplyFlow = false,
    fields = [],
    onCompleted = null,
  } = {}) => {
    setProfileApplyFlow(isApplyFlow);
    setMissingFields(fields);
    setOnProfileCompleted(() => onCompleted);
    setShowProfilePopUp(true);
  };

  const closeProfile = () => {
    setShowProfilePopUp(false);
    setProfileApplyFlow(false);
    setMissingFields([]);
    setOnProfileCompleted(null);
  };

  return (
    <ShowProfileContext.Provider
      value={{
        showProfile,
        closeProfile,
        showProfilePopUp,
        profileApplyFlow,
        missingFields,
        onProfileCompleted,
      }}
    >
      {children}
    </ShowProfileContext.Provider>
  );
};

export default ShowProfileContextProvider;
